/**
 * Turn an axios / fetch error into a short, human-friendly message.
 *
 * Prefers the backend's `detail` field (FastAPI style), which may be a
 * string or a list of validation errors, and falls back to a friendly
 * network message or the provided fallback text.
 */
export const getErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  if (!error) return fallback;
  if (error.userMessage) return error.userMessage;

  const data = error.response?.data;
  const detail = data?.detail ?? data?.message;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }
  if (Array.isArray(detail) && detail.length > 0) {
    const messages = detail
      .map((d) => (typeof d === 'string' ? d : d?.msg))
      .filter(Boolean);
    if (messages.length > 0) return messages.join('. ');
  }

  if (!error.response && (error.code === 'ERR_NETWORK' || error.message === 'Network Error')) {
    return 'We could not reach the server. Please check your connection and try again.';
  }

  return fallback;
};
